<script>
  export default {
    name: 'NodeFilterer',
    functional: true,
    render: function (createElement, context) {
      const {
        nodes,
        render
      } = context.props

      let count = 0

      const filteredNodes = nodes.filter(function (node) {
        // exclude white space
        if (isWhiteSpace(node)) {
          return false
        }

        // exclude nodes that aren't components
        if (isNotAComponent(node)) {
          return false
        }

        // exclude other components
        if (isSomeOtherComponent(node, render)) {
          return false
        }

        // add id prop to component
        // based off the count
        addIdPropToNode(node, count)

        count = count + 1

        return true
      })

      return filteredNodes
    },
    props: {
      nodes: {
        required: true,
        type: Array
      },
      render: {
        required: true,
        type: Array
      }
    }
  }

  const addIdPropToNode = function (node, id) {
    const noProps = typeof node.componentOptions.propsData === 'undefined'

    if (noProps) {
      return
    }

    node.componentOptions.propsData.id = id
  }

  const isNotAComponent = function (node) {
    const isNotAComponent = typeof node.componentOptions === 'undefined'

    if (isNotAComponent) {
      return true
    }

    return false
  }

  const isWhiteSpace = function (node) {
    const isWhiteSpace = typeof node.tag === 'undefined'

    if (isWhiteSpace) {
      return true
    }

    return false
  }

  const isSomeOtherComponent = function (node, whiteList) {
    const {
      tag
    } = node.componentOptions

    const isTheRightComponent = whiteList.includes(tag)

    if (isTheRightComponent) {
      return false
    }

    return true
  }
</script>



// WEBPACK FOOTER //
// src/js/components/NodeFilterer.vue